//------------------
// load race values
//------------------
export default function loadRaceValues(existing_race, char_default_val, char_min, char_max) {
  // console.log("--------------------------");
  // console.log("IN loadRaceValues");
  // ----------------------
  // define race structure
  // ----------------------
  let race = {
    //
    id: existing_race.id,
    slug: existing_race.slug,
    name: existing_race.name,
    //
    ca: 0,
    cr: 0,
    sr: 0,
    move: existing_race.move,
    move_fly: existing_race.move_fly,
    damage_mod: '',
    //
    str: 0,
    str_min: 0,
    str_max: 0,
    str_dice_roll: 0,
    //
    con: 0,
    con_min: 0,
    con_max: 0,
    con_dice_roll: 0,
    //
    dex: 0,
    dex_min: 0,
    dex_max: 0,
    dex_dice_roll: 0,
    //
    siz: 0,
    siz_min: 0,
    siz_max: 0,
    siz_dice_roll: 0,
    //
    int: 0,
    int_min: 0,
    int_max: 0,
    int_dice_roll: 0,
    //
    pow: 0,
    pow_min: 0,
    pow_max: 0,
    pow_dice_roll: 0,
    //
    cha: 0,
    cha_min: 0,
    cha_max: 0,
    cha_dice_roll: 0,
    //
    special_action: existing_race.special_action,
    special_reaction: existing_race.special_reaction,
    character_race: existing_race.character_race,
    //
    image: existing_race.image,
  }
  // ---------------------------------------------------------------
  // missing chars - initial setup where race record already exists
  // ---------------------------------------------------------------
  if (existing_race.characteristics == null) {
    //
    race.str = char_default_val
    race.str_min = char_min
    race.str_max = char_max
    race.str_dice_roll = 0
    //
    race.con = char_default_val
    race.con_min = char_min
    race.con_max = char_max
    race.con_dice_roll = 0
    //
    race.dex = char_default_val
    race.dex_min = char_min
    race.dex_max = char_max
    race.dex_dice_roll = 0
    //
    race.siz = char_default_val
    race.siz_min = char_min
    race.siz_max = char_max
    race.siz_dice_roll = 0
    //
    race.int = char_default_val
    race.int_min = char_min
    race.int_max = char_max
    race.int_dice_roll = 0
    //
    race.pow = char_default_val
    race.pow_min = char_min
    race.pow_max = char_max
    race.pow_dice_roll = 0
    //
    race.cha = char_default_val
    race.cha_min = char_min
    race.cha_max = char_max
    race.cha_dice_roll = 0
    //
  } else {
    // --------------------------
    // load existing char values
    // --------------------------
    let race_str_char = existing_race.characteristics.find((c) => c.name == 'str')
    race.str = race_str_char.value
    race.str_min = race_str_char.min
    race.str_max = race_str_char.max
    race.str_dice_roll = race_str_char.dice_roll ?? 0
    //
    let race_con_char = existing_race.characteristics.find((c) => c.name == 'con')
    race.con = race_con_char.value
    race.con_min = race_con_char.min
    race.con_max = race_con_char.max
    race.con_dice_roll = race_con_char.dice_roll ?? 0
    //
    let race_dex_char = existing_race.characteristics.find((c) => c.name == 'dex')
    race.dex = race_dex_char.value
    race.dex_min = race_dex_char.min
    race.dex_max = race_dex_char.max
    race.dex_dice_roll = race_dex_char.dice_roll ?? 0
    //
    let race_siz_char = existing_race.characteristics.find((c) => c.name == 'siz')
    race.siz = race_siz_char.value
    race.siz_min = race_siz_char.min
    race.siz_max = race_siz_char.max
    race.siz_dice_roll = race_siz_char.dice_roll ?? 0
    //
    let race_int_char = existing_race.characteristics.find((c) => c.name == 'int')
    race.int = race_int_char.value
    race.int_min = race_int_char.min
    race.int_max = race_int_char.max
    race.int_dice_roll = race_int_char.dice_roll ?? 0
    //
    let race_pow_char = existing_race.characteristics.find((c) => c.name == 'pow')
    race.pow = race_pow_char.value
    race.pow_min = race_pow_char.min
    race.pow_max = race_pow_char.max
    race.pow_dice_roll = race_pow_char.dice_roll ?? 0
    //
    let race_cha_char = existing_race.characteristics.find((c) => c.name == 'cha')
    race.cha = race_cha_char.value
    race.cha_min = race_cha_char.min
    race.cha_max = race_cha_char.max
    race.cha_dice_roll = race_cha_char.dice_roll ?? 0
  }
  return race
}
